module.exports = __webpack_public_path__ + "static/media/logo-leapfrog.2a7cda8d.png";